import { render, staticRenderFns } from "./sketch.vue?vue&type=template&id=655b9c9c&scoped=true&"
import script from "./sketch.vue?vue&type=script&lang=js&"
export * from "./sketch.vue?vue&type=script&lang=js&"
import style0 from "./sketch.vue?vue&type=style&index=0&id=655b9c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b9c9c",
  null
  
)

export default component.exports